export default __webpack_public_path__ + "static/media/ic_group_add_48px.eae6a426.svg";